import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { allReviewsUrl } from '../../../components/Reviews/constants';
import Assets from '../Assets';
import css from './NotForSale.module.scss';
import Instagrams from '../Instagrams';
import Rating from '../../../components/Rating';
import RecommendationsAI from '../../../components/RecommendationsAI';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var NotForSale = function NotForSale(_ref) {
  var assets = _ref.assets,
      instagrams = _ref.instagrams,
      properties = _ref.properties,
      rating = _ref.rating,
      shopifyId = _ref.shopifyId,
      title = _ref.title,
      variantId = _ref.variantId;
  var description = properties.description,
      recommendation = properties.recommendation,
      reviewCount = properties.reviewCount;
  var allReviews = allReviewsUrl(shopifyId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("section", {
      className: css.root,
      children: [/*#__PURE__*/_jsx(Assets, _objectSpread(_objectSpread({}, properties), {}, {
        assets: assets,
        title: title
      })), /*#__PURE__*/_jsxs("div", {
        className: css.properties,
        children: [/*#__PURE__*/_jsx("h1", {
          className: css.title,
          children: title
        }), reviewCount > 0 && /*#__PURE__*/_jsxs("a", {
          className: css.writeReview,
          href: allReviews,
          children: [/*#__PURE__*/_jsx(Rating, {
            count: 5,
            value: rating,
            size: 12
          }), /*#__PURE__*/_jsx("span", {
            children: "".concat(reviewCount, " review").concat(reviewCount === 1 ? '' : 's')
          })]
        }), !reviewCount && /*#__PURE__*/_jsx("a", {
          className: css.writeReview,
          href: allReviews,
          children: "Write the first review"
        }), /*#__PURE__*/_jsx("p", {
          className: css.description,
          children: description
        }), /*#__PURE__*/_jsxs("p", {
          children: ["Available as part of an ", /*#__PURE__*/_jsx("a", {
            href: "/collections/ov-kits",
            children: "OV Kit"
          }), ' ', "purchase"]
        })]
      })]
    }), instagrams.length > 0 && /*#__PURE__*/_jsx(Instagrams, {
      items: instagrams,
      label: title
    }), recommendation && /*#__PURE__*/_jsx(RecommendationsAI, _objectSpread(_objectSpread({}, recommendation), {}, {
      variantIds: [variantId]
    }))]
  });
};

NotForSale.defaultProps = {
  customDetailDrawer: false,
  ugcSet: null
};
NotForSale.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    src: PropTypes.string
  })).isRequired,
  customDetailDrawer: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    description: PropTypes.string,
    title: PropTypes.string
  })]),
  instagrams: PropTypes.arrayOf(PropTypes.shape({})),
  sizeGuide: PropTypes.string.isRequired,
  properties: PropTypes.shape({
    description: PropTypes.string,
    recommendation: PropTypes.shape(),
    reviewCount: PropTypes.number.isRequired
  }).isRequired,
  rating: PropTypes.number.isRequired,
  shopifyId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  variantId: PropTypes.number.isRequired
};
export default NotForSale;